export default "__VITE_ASSET__Cf8FxzxH__"